export default "__VITE_ASSET__rkuBp$gB__"